import { render } from "./Secondary2.vue?vue&type=template&id=e2f4b6d2&ts=true"
import script from "./Secondary2.vue?vue&type=script&lang=ts"
export * from "./Secondary2.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/images/avatars/Secondary2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2f4b6d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2f4b6d2', __exports__)) {
    api.reload('e2f4b6d2', __exports__)
  }
  
  module.hot.accept("./Secondary2.vue?vue&type=template&id=e2f4b6d2&ts=true", () => {
    api.rerender('e2f4b6d2', render)
  })

}


export default __exports__